module.exports = __webpack_public_path__ + "static/img/mypage_icon01.863661bf.svg";